import { Box } from '@mui/material';

import MapPezinhoRange from './MapPezinhoRange';
import MapPezinhoVehicles from './MapPezinhoVehicles';

export default function MapPezinhoPanel() {

    return (
        <Box
            sx={{
                width: 360,

                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
                gap: 0.5
            }}
        >
            <MapPezinhoRange />

            <MapPezinhoVehicles />
        </Box>
    );
}